import { Stack } from '@mui/material';
// import { bgBlur } from 'theme/css';
import { useNavContext } from '../use-nav-context';
import { NavItem } from './nav-item';
import { NavEntity } from 'types/header';

export const DesktopNavigation = ({ items }: { items: NavEntity[] }) => {
  const navContext = useNavContext();

  return (
    <Stack
      direction="row"
      spacing={3}
      component="ul"
      sx={{
        listStyle: 'none',
        display: 'flex',
        alignItems: 'center',
        p: '6px 18px',
        borderRadius: '8px',
        // ...bgBlur({
        //   color: 'rgba(244, 244, 244, 0.6)',
        // }),
      }}
    >
      {items.map(item => (
        <NavItem key={item.title} item={item} navContext={navContext} />
      ))}
    </Stack>
  );
};
